// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"0319346b","601":"a0aa26db","631":"c295725e"}[chunkId] + ".chunk.css";
};